import React, { useState } from "react";

export const useRoundUp = () => {
    const [shouldRoundUp, setShouldRoundUp] = useState(false);
    const [roundUpAmount, setRoundUpAmount] = useState('0.00');

    return {
        roundUpAmount,
        setRoundUpAmount,
        setShouldRoundUp,
        shouldRoundUp,
    };
}

const RoundUp = (props) => {
    const {
        donationAmount,
        roundUpAmount,
        setShouldRoundUp,
        shouldRoundUp,
    } = props;

    if(donationAmount == '0.00' || roundUpAmount == '0.00') {
        return "";
    }

    // Component is disabled for now.
    return "";

    return (
        <div className="ticket-summary__round">
            <h5 className="ticket-summary__heading">Round Up<hr/></h5>
            <div className="fieldgroup fieldgroup--checkbox">
                <input type="checkbox" id="round-up" checked={shouldRoundUp} onClick={() => setShouldRoundUp(!shouldRoundUp)}/>
                <label htmlFor="round-up">Support the Seattle Aquarium and round my order up by ${roundUpAmount}.</label>
            </div>
        </div>
    )
}

export default RoundUp;